const step=(title,math)=>({title,math});
export function getPolynomialOperationSolutionSteps(task){
 const v=task.data?.values;if(!v)return null;
 switch(task.type){
  case "MaturaBasic_SumPolynomialCoefficientsUsingValueOne":{
   const [b,a]=v,answer=(a-b)**3;return [
    step("Podstawiamy x=1 do zapisu ogólnego. Każda potęga jedynki jest równa jeden, dlatego wartość W(1) jest sumą współczynników.",String.raw`W(1)=a\cdot1^3+b\cdot1^2+c\cdot1+d=a+b+c+d`),
    step("Tę samą wartość obliczamy z podanego iloczynu, bez rozwijania wszystkich nawiasów.",String.raw`W(1)=(${b}-${a}\cdot1)^2(${a}\cdot1-${b})=(${b-a})^2\cdot(${a-b})=${answer}`),
    step("Podajemy obliczoną sumę współczynników.",String.raw`a+b+c+d=${answer}`),
   ];
  }
  case "MaturaBasic_CubicGroupingFactorizationClosed":{
   const [a,b]=v;return [
    step("Sprawdzamy podaną postać iloczynową. Mnożymy każdy składnik pierwszego nawiasu przez oba składniki drugiego.",String.raw`(x-${a})(x^2-${b})=x\cdot x^2+x\cdot(-${b})+(-${a})\cdot x^2+(-${a})\cdot(-${b})`),
    step("Obliczamy iloczyny i porządkujemy wyrazy. Otrzymujemy dokładnie podany wielomian.",String.raw`x^3-${b}x-${a}x^2+${a*b}=x^3-${a}x^2-${b}x+${a*b}=W(x)`),
    {optional:true,title:"Inna metoda: grupowanie",math:String.raw`x^2(x-${a})-${b}(x-${a})=(x-${a})(x^2-${b})`},
   ];
  }
  case "MaturaBasic_PolynomialGivenLinearFactorParameter":{
   const [a,b,c]=v,k=a-b+c;return [
    step("Podstawiamy −1 do podanej postaci iloczynowej. Czynnik x+1 znika, więc cały wielomian ma wartość zero.",String.raw`W(-1)=(-1+1)Q(-1)=0`),
    step("Podstawiamy tę samą liczbę do wzoru wielomianu. Potęga nieparzysta liczby −1 jest ujemna, a parzysta dodatnia.",String.raw`W(-1)=-${a}(-1)^3-${b}(-1)^2+k(-1)+${c}=${a}-${b}-k+${c}`),
    step("Przyrównujemy wartość do zera i obliczamy parametr.",String.raw`${a}-${b}-k+${c}=0\iff k=${k}`),
   ];
  }
  case "MaturaBasic_PolynomialFactorizationAndRootTruth":{
   const [a,b,c,x]=v,w=a*x*(x*x+b*x+c);return [
    step("Sprawdzamy pierwsze zdanie przez wymnożenie podanych wielomianów.",String.raw`${a}x(x^2+${b}x+${c})=${a}x^3+${a*b}x^2+${a*c}x=W(x)`),
    step("Iloczyn jest równy W(x), więc pierwsze zdanie jest prawdziwe. Następnie podstawiamy liczbę z drugiego zdania.",String.raw`W(${x})=${a}(${x})^3+${a*b}(${x})^2+${a*c}(${x})=${w}`),
    step(w===0?"Wartość wynosi zero, więc podana liczba jest rozwiązaniem. Drugie zdanie jest prawdziwe.":"Wartość jest różna od zera, więc podana liczba nie jest rozwiązaniem. Drugie zdanie jest fałszywe.",String.raw`W(${x})${w===0?"=":"\\ne"}0`),
   ];
  }
  default:return null;
 }
}
